document.addEventListener("DOMContentLoaded", function() {

    // --- 1. Referenzen holen ---
    const brandSelect = document.getElementById('filter-brand');
    const countrySelect = document.getElementById('filter-country');
    const items = document.querySelectorAll('.rsce_sales_wrapper .item');
    const hintBox = document.getElementById('filter-hint'); // Referenz für den Hinweistext

    // URL Parameter einmal zentral holen
    const urlParams = new URLSearchParams(window.location.search);
    const preCountry = urlParams.get('country');
    const preBrand = urlParams.get('brand');

    if (items.length > 0) {

        // --- A) LÄNDER SAMMELN ---
        if (countrySelect) {
            const countryCodes = new Set();
            items.forEach(item => {
                if (item.dataset.country) countryCodes.add(item.dataset.country.toUpperCase());
            });

            const countryList = [];
            const pageLang = document.documentElement.lang || 'de';
            let regionNames;
            try { regionNames = new Intl.DisplayNames([pageLang], {type: 'region'}); } catch (e) {}

            countryCodes.forEach(code => {
                let displayName = code;
                if (regionNames) {
                    try { displayName = regionNames.of(code); } catch (e) { if (code === 'XK') displayName = 'Kosovo'; }
                }
                countryList.push({ code: code.toLowerCase(), name: displayName.toUpperCase() });
            });

            countryList.sort((a, b) => a.name.localeCompare(b.name));

            countryList.forEach(c => {
                const option = document.createElement('option');
                option.value = c.code;
                option.textContent = c.name;
                // Hier wird die Vorauswahl getroffen:
                if (preCountry && preCountry.toLowerCase() === c.code) option.selected = true;
                countrySelect.appendChild(option);
            });
        }

        // --- B) MARKEN SAMMELN ---
        if (brandSelect) {
            const brandMap = new Map();

            items.forEach(item => {
                const slug = item.dataset.brand;
                const label = item.dataset.brandLabel;

                if (slug && label) {
                    if (!brandMap.has(slug)) {
                        brandMap.set(slug, label.toUpperCase());
                    }
                }
            });

            const brandList = Array.from(brandMap, ([code, name]) => ({ code, name }));

            brandList.sort((a, b) => a.name.localeCompare(b.name));

            brandList.forEach(b => {
                const option = document.createElement('option');
                option.value = b.code;
                option.textContent = b.name;
                // Hier wird die Vorauswahl getroffen:
                if (preBrand && b.code.includes(preBrand.toLowerCase())) {
                    option.selected = true;
                }
                brandSelect.appendChild(option);
            });
        }
    }

    // --- 2. Event Listener ---
    if (brandSelect) brandSelect.addEventListener('change', runFilter);
    if (countrySelect) countrySelect.addEventListener('change', runFilter);

    // --- 3. Initialer Start ---
    // Wenn wir Parameter in der URL hatten, müssen wir den Filter einmal ausführen,
    // damit die nicht-passenden Items ausgeblendet werden.
    if (preCountry || preBrand) {
        runFilter();
    }

    // --- 4. Die Filter-Logik ---
    function runFilter() {
        const selBrand = brandSelect ? brandSelect.value.toLowerCase() : 'all';
        const selCountry = countrySelect ? countrySelect.value.toLowerCase() : 'all';

        // EMPTY STATE: Wenn beide Filter auf "all" stehen
        if (selBrand === 'all' && selCountry === 'all') {
            items.forEach(item => {
                item.classList.remove('is-visible');
                item.style.display = ''; // CSS display:none greift wieder
            });

            // Hinweis wieder einblenden (falls vorhanden)
            if (hintBox) hintBox.style.display = 'block';

            return;
        }

        // FILTER AKTIV: Hinweis ausblenden
        if (hintBox) hintBox.style.display = 'none';

        // Items filtern
        items.forEach(item => {
            const itemBrand = (item.dataset.brand || '').toLowerCase();
            const itemCountry = (item.dataset.country || '').toLowerCase();

            const matchBrand = (selBrand === 'all' || itemBrand.includes(selBrand));
            const matchCountry = (selCountry === 'all' || itemCountry === selCountry);

            if (matchBrand && matchCountry) {
                // Treffer
                item.style.display = 'block';
                requestAnimationFrame(() => {
                    item.classList.add('is-visible');
                });
            } else {
                // Kein Treffer
                item.classList.remove('is-visible');
                item.style.display = 'none';
            }
        });
    }
});